const onSlider = (elm, e) => {
	cursor.setStatus(1);
	cursor.changeCursor();
};

const initGallerySlider = (e) => {
	const sliderObj = e;
	e.slides.forEach((elm, i) => {
		const items = elm.querySelectorAll('.js_modal');
		items.forEach((elm, i) => {
			elm.addEventListener('mouseenter', (e) => {
				onSlider(elm, e);
			}, false);
		});
	});
	document.body.addEventListener('mousemove', (e) => {
		if (e.target.closest('.js_modal') !== null || e.target.classList.contains('.js_modal')) {
			cursor.moveCursor(e.clientY, e.clientX);
		} else {
			resetPosSlider();
		}
	}, false);
};

const swiper = new Swiper('.galleryListSlider', {
	loop: true,
	slidesPerView: 1,
	speed: 1000,
	spaceBetween: 80,
	allowTouchMove: false,
	navigation: {
		prevEl: '.gSlider-btn-prev',
		nextEl: '.gSlider-btn-next'
	},
	pagination: {
		el: '.js_pager',
		clickable: true,
		bulletClass: 'pager__item',
		bulletActiveClass: 'current',
	},
	on: {
		init: initGallerySlider,
	}
});

const swiperSP = new Swiper('.galleryListSliderSP', {
	loop: true,
	slidesPerView: 1,
	speed: 1000,
	spaceBetween: 40,
	navigation: {
		prevEl: '.gSliderSP-btn-prev',
		nextEl: '.gSliderSP-btn-next'
	},
	pagination: {
		el: '.js_pagerSP',
		clickable: true,
		bulletClass: 'pager__item',
		bulletActiveClass: 'current',
	}
});

const prlxElms = document.querySelectorAll('.js_prlx_delay');
const prlxFunc = () => {
	const n = (document.scrollingElement.scrollTop - window.innerHeight / 2) * 0.05;
	gsap.to('.js_prlx_delay', { y: -n });
};
window.addEventListener('load', prlxFunc, false);
window.addEventListener('scroll', prlxFunc, false);
